<template>
  <div id="external"></div>
</template>

<script>
export default {
  name: "External",
  data() {
    return {};
  },
  methods: {
    getQuery(name) {
      return this.$route.query[name] || null;
    },
    setLocStor(data) {
      for (const key in data) {
        localStorage.setItem(key, data[key]);
      }
    },
    initAuth() {
      // 用户信息
      const defaultLocal = {
        username: "",
        userid: "",
        pic: "",
        partadmin: "",
      };
      this.setLocStor(defaultLocal);
    },
    getAuth() {
      const service = "Index.check";
      const type = "xt";

      const token = this.getQuery("token");
      const examType = this.getQuery("examType");
      const examId = this.getQuery("examId");
      const wid = this.getQuery("wid");
      const aid = this.getQuery("aid");

      this.initAuth();
      const url = `${this.HOME}?service=${service}&token=${token}&type=${type}`;
      this.$axios.get(url).then((res) => {
        const { data: data1 } = { ...res };
        const { ret, msg, data } = { ...data1 };
        if (ret !== 200) {
          this.$message.warning("获取用户信息失败:" + msg);
          return;
        }
        const {
          head_pic: pic,
          nickname: username,
          partadmin,
          user_id: userid,
        } = { ...data };
        const userMsg = { username, userid, pic, partadmin };
        this.setLocStor(userMsg);

        // 预览试卷
        const showPath = { path: "/previewTest/", query: { id: examId } };
        // 考试
        const examPath = {
          path: "/examTest/",
          query: { id: examId, wid, aid },
        };
        const typeList = {
          examView: showPath,
          useranswer: examPath,
        };
        const toPath = typeList[examType];
        toPath
          ? this.$router.push(toPath)
          : this.$message.warning("获取跳转地址失败");
        //  http://localhost:80/index.html#/external?examType=examView&examId=3347&token=OKrref8mY%3DRG2Ozl67WK78nC1M0M3STHF
      });
    },
  },
  mounted() {
    this.getAuth();
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/scholl/external/external.vue